import { depthLabel } from '@/common/app/modules/media/queryFanout'
import { RetentionChartItem } from '@/common/model/media/queryFanout'

import BarChart from '@/components/view/atoms/chart/BarChart'

import GeoChartCard from '@/components/container/modules/mediaGeo/common/GeoChartCard'

interface Props {
  retentionChart: RetentionChartItem[]
}

// 会話深度ごとの自社ブランドの存在と競合ブランド数の棒グラフ
const QueryFanoutRetentionChart = ({ retentionChart }: Props) => (
  <GeoChartCard title='深度別のブランド数'>
    <BarChart
      labels={retentionChart.map((item) => depthLabel(item.depth))}
      items={[
        { title: '自社ブランド数', values: retentionChart.map((item) => (item.own_brand ? 1 : 0)) },
        {
          title: '競合ブランド数',
          values: retentionChart.map((item) => item.competitors_count || 0)
        }
      ]}
    />
  </GeoChartCard>
)

export default QueryFanoutRetentionChart
